import { render, staticRenderFns } from "./Rating2023ConfigEdit.vue?vue&type=template&id=34996f4b&scoped=true"
import script from "./Rating2023ConfigEdit.vue?vue&type=script&lang=js"
export * from "./Rating2023ConfigEdit.vue?vue&type=script&lang=js"
import style0 from "./Rating2023ConfigEdit.vue?vue&type=style&index=0&id=34996f4b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34996f4b",
  null
  
)

export default component.exports